<header class="topbar">
  <button class="iconbtn" (click)="sulje()" [attr.aria-label]="'tositteet.lisaa-tositteita.sivu.takaisin-aria' | translate | async" type="button">
    <span class="material-icons" aria-hidden="true">arrow_back</span>
  </button>
  <h1>{{ 'tositteet.lisaa-tositteita.sivu.otsikko' | translate | async }}</h1>
  <div class="right-spacer" aria-hidden="true"></div>
</header>

<main class="page">
  @if (yhteysvirheAvain()) {
    <div class="validation-banner yhteysvirhe" role="alert">
      <span class="material-symbols-outlined" aria-hidden="true">wifi_off</span>
      {{ yhteysvirheAvain() | translate | async }}
    </div>
  }

  @if ((tositteidenMaaraObservable | async) === 0) {
    <app-tosite-pudotusalue (tiedostotValittu)="tiedostotValittu($event)"></app-tosite-pudotusalue>
  } @else {
    <div class="blocks">
      @for (tosite of (tositteetObservable | async) ?? []; track tosite.id; let i = $index) {
        <app-tosite-kortti [tosite]="tosite" [jarjestysnumero]="i + 1" [alvPortaat]="(alvPortaatObservable | async) ?? null" [naytaVirheet]="naytaVirheet()" [lukittu]="selvitettavaMoodi" (poistaTosite)="poistaTosite(tosite.id)" (lisaaSivuja)="lisaaSivuja(tosite.id, $event)" (poistaSivu)="poistaSivu(tosite.id, $event)" (keskeytaLuku)="keskeytaLuku(tosite.id)" (yritaUudelleen)="yritaLahetysUudelleen(tosite.id)" (ohitaLisays)="ohitaLisays(tosite.id)" (poistaEpaonnistuneet)="poistaEpaonnistuneetSivut(tosite.id)"> </app-tosite-kortti>
      }
    </div>

    @if (!selvitettavaMoodi) {
      <app-tosite-pudotusalue [tiivis]="true" (tiedostotValittu)="tiedostotValittu($event)"></app-tosite-pudotusalue>
    }
  }

  @if (kuvavirheAvain()) {
    <div class="validation-banner" role="alert">
      <span class="material-symbols-outlined" aria-hidden="true">info</span>
      {{ kuvavirheAvain() | translate: kuvavirheParametrit() | async }}
    </div>
  }

  @if (tallennusvirheAvain()) {
    <div class="validation-banner" role="alert">
      <span class="material-symbols-outlined" aria-hidden="true">info</span>
      {{ tallennusvirheAvain() | translate | async }}
    </div>
  }
</main>

@if ((tositteidenMaaraObservable | async) ?? 0) {
  @let tallennettavienMaara = (tallennettavienMaaraObservable | async) ?? 0;
  @let estot = tallennuksenEstotObservable | async;
  <div class="savebar">
    <div class="summary">
      @if (naytaVirheet() && tallennettavienMaara > 0 && estot) {
        @if (estot.korjattavienMaara > 0) {
          <div class="tallennus-esto" role="alert">
            <span class="material-symbols-outlined" aria-hidden="true">error</span>
            {{ 'tositteet.lisaa-tositteita.sivu.tallennus-estetty.korjattavia' | translate: { maara: estot.korjattavienMaara } | async }}
          </div>
        } @else if (estot.odottaviaLatauksia || estot.odottaviaLukuja) {
          <div class="tallennus-esto odottaa" role="status">
            <span class="material-symbols-outlined" aria-hidden="true">schedule</span>
            {{ (estot.odottaviaLatauksia ? 'tositteet.lisaa-tositteita.sivu.tallennus-estetty.lataus-kesken' : 'tositteet.lisaa-tositteita.sivu.tallennus-estetty.luku-kesken') | translate | async }}
          </div>
        }
      }
    </div>
    @if (tallennettavienMaara > 1) {
      <button class="btn-secondary" type="button" (click)="yhdistaTositteet()" [attr.aria-label]="'tositteet.lisaa-tositteita.sivu.yhdista-aria' | translate | async">
        <span class="material-symbols-outlined" aria-hidden="true">merge</span>
        {{ 'tositteet.lisaa-tositteita.sivu.yhdista' | translate | async }}
      </button>
    }
    <button class="btn-primary" type="button" [disabled]="tallennettavienMaara === 0" (click)="tallennaTositteet()" [attr.aria-label]="'tositteet.lisaa-tositteita.sivu.tallenna-aria' | translate | async">
      {{ 'tositteet.lisaa-tositteita.sivu.tallenna' | translate | async }}
      @if (tallennettavienMaara > 1) {
        ({{ tallennettavienMaara }})
      }
    </button>
  </div>
}
